module.exports = __webpack_public_path__ + "assets/3a90915deaa4a15734146fa3c7822cda.png";